import { RootState } from './../../app/store';

export const selectUser = (state: RootState) => state.currentUser;
export const selectAccessToken = (state: RootState) => state.currentUser.accessToken || null;
export const selectRefreshToken = (state: RootState) => state.currentUser.refreshToken || null;